// MoreAppsByUs.tsx
import { dashboardImage } from '@/asset/images/dashboard';
import BoldText from '@/components/BoldText';
import Card from '@/components/card';
import RegularText from '@/components/RegularText';
import { Button, InlineGrid, Card as ShopifyCard } from '@shopify/polaris';
import { AppCard } from './styled';

function MoreAppsByUs() {
  const apps = [
    {
      logo: dashboardImage.edd,
      name: 'S: Estimated Delivery Date',
      description:
        'Show estimated delivery dates on product pages to increase trust and reduce pre-sale questions. Customize rules by region, zip code, product type, and more. Works perfectly across desktop and mobile.',
      link: 'https://www.wix.com/app-market/s-estimated-delivery-date-eta',
    },
    {
      logo: dashboardImage.age,
      name: 'Blockify Age Verification 18+',
      description:
        'Display a stylish 18+ popup to verify customer age before entering your site. Compliant with age-sensitive content laws. Customize the design, message, and redirect options to match your brand.',
      link: 'https://www.wix.com/app-market/age-verify',
    },
    {
      logo: dashboardImage.chat,
      name: 'Omega WhatsApp & Contact Form',
      description:
        'Add WhatsApp, Messenger & Contact Forms to your Wix site in seconds. Chat live, auto‑capture leads, and manage every conversation from one unified inbox.',
      link: 'https://www.wix.com/app-market/omega-chat-form',
    },
    {
      logo: dashboardImage.synctrack,
      name: 'Synctrack Sync PayPal Tracking',
      description:
        'Protect your PayPal account by syncing order tracking info in real-time. Avoid disputes, holds & chargebacks effortlessly. Trusted by thousands of merchants worldwide.',
      link: 'https://www.wix.com/app-market/synctrack',
    },
  ];

  return (
    <div className="mt-16">
      <Card title="More apps by us">
        <InlineGrid
          columns={{ xl: 2, lg: 2, md: 2, sm: 2, xs: 2 }}
          gap={{ lg: '400', md: '400', xl: '400', sm: '400', xs: '400' }}
        >
          {apps.map((app, index) => (
            <AppCard key={index}>
              <ShopifyCard>
                <div className="d-flex gap-16">
                  <img src={app.logo} alt={app.name} />
                  <div>
                    <BoldText>{app.name}</BoldText>
                    <div className="mt-4">
                      <RegularText>{app.description}</RegularText>
                    </div>
                    <div className="mt-16">
                      <Button
                        onClick={() => {
                          window.open(app.link, '_blank', 'noopener,noreferrer');
                        }}
                      >
                        Get App
                      </Button>
                    </div>
                  </div>
                </div>
              </ShopifyCard>
            </AppCard>
          ))}
        </InlineGrid>
      </Card>
    </div>
  );
}

export default MoreAppsByUs;
